import React from 'react';
import { useParams } from 'react-router-dom';
import { Settings, ArrowLeft } from 'lucide-react';

const EquipmentDetail = () => {
  const { id } = useParams();

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <button
          onClick={() => window.history.back()}
          className="btn btn-secondary"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Equipment Detail</h1>
          <p className="text-gray-600">Equipment ID: {id}</p>
        </div>
      </div>

      <div className="card p-8 text-center">
        <Settings className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Equipment Detail Page
        </h3>
        <p className="text-gray-600 mb-4">
          Detailed equipment monitoring, sensor data, and maintenance history will be available in the full implementation.
        </p>
        <p className="text-sm text-gray-500">
          This MVP focuses on the role-based dashboard system and core authentication features.
        </p>
      </div>
    </div>
  );
};

export default EquipmentDetail; 